import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import AboutPage from "../pages/about/page";
import ServicesPage from "../pages/services/page";
import ContactPage from "../pages/contact/page";
// import InsightsPage from "../pages/insights/page";
import CredentialsPage from "../pages/credentials/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <AboutPage />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  // {
  //   path: "/insights",
  //   element: <InsightsPage />,
  // },
  {
    path: "/credentials",
    element: <CredentialsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
